import { createFileRoute } from "@tanstack/react-router";
import { useAuth } from "@/lib/auth";
import { AlertCenter } from "@/components/alerts/AlertCenter";

export const Route = createFileRoute("/_authenticated/alerts")({
  component: AlertsPage,
  head: () => ({ meta: [{ title: "Alert Center — MissionReady" }] }),
});

function AlertsPage() {
  const { currentOrg, currentRole } = useAuth();
  const canManage = ["org_owner", "admin", "supervisor"].includes(currentRole ?? "");
  if (!currentOrg) return <div className="p-8 text-sm text-muted-foreground">Select an organization.</div>;
  return (
    <div className="mx-auto max-w-6xl px-4 py-8 md:px-8">
      <h1 className="mb-1 text-3xl font-semibold tracking-tight">Alert Center</h1>
      <p className="mb-6 text-sm text-muted-foreground">
        Real-time security alerts across patrols, scans, and officer activity.
      </p>
      <AlertCenter organizationId={currentOrg.id} canManage={canManage} />
    </div>
  );
}
